<template>
  <div>
    <div class="container">
      <div class="row justify-content-between">
        <div class="px-2">
          <el-form
            ref="queryForm"
            :model="queryForm"
            label-width="100px"
            :inline="true"
            @keyup.enter.native="handleQueryClick(queryForm)"  @submit.native.prevent
          >
            <el-form-item label="頻道" label-width="50px">
              <el-select
                v-model="queryForm.chnl"
                class="selectqry"
                size="small"
                :disabled="hasNoValidChnl"
              >
                <el-option
                  v-for="item in myChnls"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                 <el-tooltip v-if="item.isSystem" content="系統頻道，勿公開、勿分享">
                <i class="el-icon-setting">{{ item.name }}</i>
               </el-tooltip>
                <span v-else
                  >{{ item.name }}</span>
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="關鍵字" label-width="60px">
              <el-input
                size="small"
                :disabled="hasNoValidChnl"
                v-model="queryForm.qstr"
                placeholder="名稱"
                style="width:130px"
              ></el-input>
            </el-form-item>

            <!--<el-form-item label="顏色">-->
            <!--<el-checkbox-group v-model="queryForm.colors">-->
            <!--<el-checkbox-->
            <!--v-for="itemColor in tagColorList"-->
            <!--:key="itemColor.value"-->
            <!--:label="itemColor.value"-->
            <!--:style="{ color: itemColor.txtColor }" >-->
            <!--{{ itemColor.txtLabel }}</el-checkbox >-->
            <!--</el-checkbox-group>-->
            <!--</el-form-item>-->

            <el-form-item>
              <el-button
                type="primary"
                @click="handleQueryClick(queryForm)"
                size="small"
                :disabled="hasNoValidChnl"
                >查詢</el-button
              >
            </el-form-item>
          </el-form>
        </div>
        <div class="funcpanel">
          <el-button
            type="primary"
            icon="el-icon-edit"
            @click="editWhitelist"
            size="small"
            :disabled="hasNoValidChnl"
            >編輯單位白名單</el-button
          >
        </div>
      </div>
    </div>

    <el-alert
      v-if="hasInited && hasNoValidChnl"
      title="目前沒有非公開頻道"
      :closable="false"
      show-icon
      class="mb-2"
      type="warning">
    </el-alert>

    <CCard>
      <CCardHeader>
        <CIcon name="cib-apple-podcasts" /> 頻道：{{
          hasNoValidChnl
            ? ""
            : getChnlName(activeQueryForm.chnl)
        }}
      </CCardHeader>
      <CCardBody>
        <CRow>
          <el-table
          :border="true"
            :data="whiteOrgs"
            @sort-change="sortChange"
            :default-sort="{ prop: defaultSortCol, order: defaultOrder }"
            stripe
            style="width: 100%"
          >
            <el-table-column
              type="index"
              :index="indexFormatter"
              prop="id"
              fixed
            >
            </el-table-column>

            <el-table-column
              label="已分享單位"
              prop="name"
              sortable="custom"
              width="250"
            >
              <template #default="scope">
                <el-tag :style="getTagStyle(scope.row.organization.color)">{{
                  scope.row.organization.name
                }}</el-tag>
              </template>
            </el-table-column>

            <el-table-column label="操作">
              <template #default="scope">
                <el-button
                  type="danger"
                  size="mini"
                  @click="delWhiteOrg(scope.row.id)"
                  >刪除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </CRow>
        <CRow>
          <el-pagination
            :disabled="hasNoValidChnl"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :page-sizes="[50, 100, 200]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </CRow>
        <EditOrgWhitelistDlg
          v-model="isDlgVisible"
          :channelName="getChnlName(activeQueryForm.chnl)"
          :channelId="activeQueryForm.chnl"
          :key="dlgKey"
        ></EditOrgWhitelistDlg>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import EditOrgWhitelistDlg from "@/components/gblchnl/EditOrgWhitelistDlg";
import tagColorsMixin from "@/components/mixin/tagColors.js";
import API from "@/api/";
export default {
  mixins: [tagColorsMixin],
  components: {
    EditOrgWhitelistDlg,
  },
  created() {
    this.$store.commit("channel/CLEAR");
    this.$store.commit("chnlOrgWhitelist/CLEAR");
    this.$store.commit("chnlOrgWhitelist/SET_SORT", this.defaultSortCol);
    this.$store.commit("chnlOrgWhitelist/SET_ORDER", this.defaultOrder);
    API.my.channels().then(res => {
      const nonPbChnls = res.data.filter(chnl => !chnl.isPublic);
      this.myChnls = nonPbChnls;
      if (nonPbChnls.length) {
        this.queryForm.chnl = nonPbChnls[0].id;
        this.activeQueryForm.chnl = nonPbChnls[0].id;

        this.query(
          this.pageSize,
          0,
          this.sort,
          this.order,
          this.activeQueryForm
        );
      }
    })
    .finally(() => {
      this.hasInited = true; 
    })
  },
  data() {
    return {
      hasInited: false,
      defaultSortCol: "organization.name",
      defaultOrder: 'ascending',
      myChnls: [],
      dlgKey: 0,
      isDlgVisible: false,
      pageSize: 50,
      currentPage: 1,
      queryForm: {
        chnl: undefined,
        qstr: "",
        //colors: [],
      },
      activeQueryForm: {
        chnl: undefined,
        qstr: "",
        //colors: [],
      },
    };
  },
  methods: {
    getChnlName(chnlId) {
      const foundChnl = this.myChnls.find(chnl => chnl.id === chnlId);
      return foundChnl ? foundChnl.name : "";
    },
    handleQueryClick(queryForm) {
      this.currentPage = 1; //reset pagination to the first page
      this.activeQueryForm = { ...queryForm };
      this.query(this.pageSize, 0, this.sort, this.order, queryForm);
    },
    editWhitelist() {
      this.isDlgVisible = true;
      this.dlgKey = this.dlgKey ? 0 : 1;
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.query(val, this.offset, this.sort, this.order, this.activeQueryForm);
    },
    handleCurrentChange(page) {
      this.query(
        this.pageSize,
        this.pageSize * (page - 1),
        this.sort,
        this.order,
        this.activeQueryForm
      );
    },
    query(max, offset, sort, order, params) {
      const { chnl, ...newParams } = params;
      newParams.channel = chnl;
      this.$store.dispatch("chnlOrgWhitelist/list", {
        max: max,
        offset: offset,
        sort,
        order,
        ...newParams,
      });
    },
    indexFormatter(index) {
      return `#${parseInt(this.offset) + index + 1}`;
    },
    delWhiteOrg(itemId) {
      this.$confirm("此操作會永久將該單位移出白名單, 是否繼續?", "提示", {
        confirmButtonText: "確定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          API.chnlOrgWhitelist.removeWhiteOrg(itemId).then(() => {
            this.query(
              this.pageSize,
              this.offset,
              this.sort,
              this.order,
              this.activeQueryForm
            );
            this.$message({
              type: "success",
              message: "删除成功!",
            });
          });
        })
        .catch(() => {
          /*this.$message({*/
          /*type: 'info',*/
          /*message: '已取消删除'*/
          /*});          */
        });
    },
    sortChange(args) {
      if (this.hasNoValidChnl) {
        return;
      }
      if (args.order === null) {
        this.$store.commit("chnlOrgWhitelist/SET_SORT", this.defaultSortCol);
        this.$store.commit("chnlOrgWhitelist/SET_ORDER", this.defaultOrder);
      } else {
        this.$store.commit("chnlOrgWhitelist/SET_SORT", args.prop);
        this.$store.commit("chnlOrgWhitelist/SET_ORDER", args.order);
      }
      this.query(
        this.pageSize,
        this.offset,
        this.sort,
        this.order,
        this.activeQueryForm
      );
    },
  },
  computed: {
    hasNoValidChnl() {
      return this.myChnls.length === 0;
    },
    ...mapGetters({
      myownOrg: "auth/orgName",
      whiteOrgs: "chnlOrgWhitelist/whiteOrgs",
      total: "chnlOrgWhitelist/total",
      offset: "chnlOrgWhitelist/offset",
      sort: "chnlOrgWhitelist/sort",
      order: "chnlOrgWhitelist/order",
    }),
  },
};
</script>

<style></style>
